import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Box,
  FormControlLabel,
  Slider,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { StandardFieldProps } from './FieldTypes';
import HelperText from './HelperText';

const StandardNumberField = ({
  control,
  fieldName,
  field,
  readOnly,
}:StandardFieldProps) => (
  <Controller
    name={fieldName}
    control={control}
    render={({
      field: {
        onChange,
        // onBlur,
        value,
        // name,
        // ref,
      },
      fieldState: {
        // invalid,
        isTouched,
        // isDirty,
        error,
      },
    }) => (
      <Box>
        <FormControlLabel
          label={field.label}
          disabled={field.readOnly}
          labelPlacement="top"
          sx={{ alignItems: 'flex-start' }}
          control={(
            <Slider
              aria-label="Opacity"
              value={value}
              valueLabelDisplay="on"
              step={field.step || undefined}
              marks
              min={field.min || 0}
              max={field.max || 1}
              onChange={onChange}
              disabled={readOnly}
            />
          )}
        />
        <HelperText
          name={fieldName}
          error={isTouched && error?.message}
          description={field.description}
        />
      </Box>
    )}
  />
);

StandardNumberField.defaultProps = {
  // placeholder: '',
  description: '',
  disabled: false,
};

export default observer(StandardNumberField);
